import { Component, Inject, Input } from '@angular/core';
import { CampaignManagerItemOfferModel, CampaignManagerVoucherOfferModel, DATE_OPTIONS, DateOptions } from '@fgb/core';

@Component({
  selector: 'fgb-campaigns-v2-used-list-item',
  templateUrl: './campaigns-v2-used-list-item.component.html',
  styleUrls: ['./campaigns-v2-used-list-item.component.scss'],
})
export class CampaignsV2UsedListItemComponent {
  @Input() campaignEntitlement: CampaignManagerItemOfferModel | CampaignManagerVoucherOfferModel;

  constructor(@Inject(DATE_OPTIONS) public dateOption: DateOptions) {}

  get isVoucher(): boolean {
    return 'VoucherRedemptions' in this.campaignEntitlement;
  }

  get voucherEntitlement(): CampaignManagerVoucherOfferModel {
    return this.campaignEntitlement as CampaignManagerVoucherOfferModel;
  }

  get expiryDate(): string | null {
    return this.voucherEntitlement.ExpiryDate || this.campaignEntitlement.ExpiryDate;
  }
}
